// TODO: add unit tests - https://tasks.awstcprojects.com/browse/PLATFORM-5701
/* istanbul ignore file */
import React, { ComponentProps } from "react";
import { LocalizationProvider } from "../localization";

/**
 * Wraps arbitrary children with the ancestors needed in a LiveComponentSource component.
 *
 * Note: implementation assumes that the XPS uses xb-scripts to build, specifically for
 * the path to translation artifacts - see https://tiny.amazon.com/j95y78zr
 */
export const LiveComponentSourceBase = (props: ComponentProps<typeof LocalizationProvider>) => {
  return <LocalizationProvider {...props} />;
};
